var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo21X25 = function SvgLogo21X25(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68826",
    d: "M6.993 19.548a1.175 1.175 0 0 1 .232-.614c-1.3-1.691-5.144-5.833-6.7-11.107-.001 0-3.26 4.87 6.468 11.721Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68827",
    d: "M8.453 18.146C3.078 6.273 4.979 2.07 4.979 2.07c-1.131.094-3.911 1.949-3.731 4.5.3 4.375 4.854 10.282 6.292 12.049a3.092 3.092 0 0 1 .913-.471Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68828",
    d: "M10.407 17.839c.116 0 .23 0 .345.008.267-3.895.765-13.546.5-16.217-.283-2.829-4.6-1.448-5.256.188-1.864 4.63 1.83 13.752 2.894 16.194a6.538 6.538 0 0 1 1.517-.173Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68829",
    d: "M11.204 17.882a5.825 5.825 0 0 1 .944.185c2.218-4.445 4.039-10.274 3.692-14.179-.3-3.424-3.8-3.3-3.8-3.3.499 4.994-.522 14.573-.836 17.294Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68830",
    d: "M16.678 3.358c.555 5.607-2.9 12.772-4.01 14.9a2.52 2.52 0 0 1 .749.482c2.179-3.095 5.082-6.529 5.848-10.653a4.331 4.331 0 0 0-2.587-4.729Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68831",
    d: "M19.931 7.827c-.313 4.071-4.543 9.276-6.259 11.234a1.135 1.135 0 0 1 .118.3c10.478-6.36 6.141-11.534 6.141-11.534Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68832",
    d: "M10.408 18.331c-1.617 0-2.928.583-2.928 1.307a3.286 3.286 0 0 0 .226 1.283 2.643 2.643 0 0 0 .172.381.959.959 0 0 1 .153-.2 1.849 1.849 0 0 1 .591-.373 4.722 4.722 0 0 1 1.787-.316 5.172 5.172 0 0 1 1.4.182 2.273 2.273 0 0 1 .974.506.994.994 0 0 1 .156.2 2.729 2.729 0 0 0 .171-.381 3.3 3.3 0 0 0 .226-1.283c.001-.721-1.31-1.306-2.928-1.306Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68833",
    d: "M10.428 20.81c-1.241 0-2.247.3-2.247.666s1.006.666 2.247.666 2.247-.3 2.247-.666-1.005-.666-2.247-.666Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68834",
    d: "M11.034 23.045a14.326 14.326 0 0 0-1.831-.514c-.193-.021-.508.025-.508.4s.316 1.281 2.052 1.24c.741-.017 1.159-.187 1.257-.416s-.07-.335-.97-.71Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68835",
    d: "m10.096 22.61 1.643.538s.4.118.5-.139.116-.541-.31-.568-2.847-.163-1.833.169Z"
  })));
};
export default SvgLogo21X25;